import React from 'react'
import { Field } from 'formik'

import { Select } from '@/components/forms/formik'

import { KNOWLEDGE_BASE_UNAVAILABLE_MESSAGE, toolSourceOptions } from './tools.constants'
import { getEntityTypeOptions } from './tools.helpers'

export const LookupTypeFields = ({ fieldTypes, organizationResolved, sharePointAvailable }) => {
  return (
    <>
      <div className="tool-form__field">
        <Field
          name="entity_type"
          component={Select}
          label="Entity type"
          options={getEntityTypeOptions(fieldTypes)}
          isClearable={false}
          touchOnChange
          required
          data-testid="tool-entity-type"
        />
      </div>
      <div className="tool-form__field">
        <Field
          name="source"
          component={Select}
          label="Knowledge source"
          options={toolSourceOptions}
          isClearable={false}
          description={
            organizationResolved && !sharePointAvailable
              ? KNOWLEDGE_BASE_UNAVAILABLE_MESSAGE
              : undefined
          }
        />
      </div>
    </>
  )
}
